import { forkJoin } from 'rxjs';
import { ImageService } from './../../_services/image.service';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Question } from 'src/app/_models/question';
import { QuizEnvelop } from 'src/app/_models/quizEnvelop';



@Component({
  selector: 'app-show-question',
  templateUrl: './show-question.component.html',
  styleUrls: ['./show-question.component.css']
})
export class ShowQuestionComponent implements OnInit {
  @Input() question= new Question()
  @Input() learner:any = {}
  @Input() quizEnvelop= new QuizEnvelop()
  @Input() myQuiz:Object = undefined
  @Input() myCount=0

  @Output() renderMathRequest = new EventEmitter<boolean>()

  @Input() isGrouping:boolean=false
  question_count=0
  loading = true
  generating=false
  reloading=false
  questionText=undefined

  constructor(private imageService:ImageService) {

   }

  ngOnInit(): void {
    this.processImages(this.question)
    this.question_count = this.isGrouping ? this.myQuiz['question_count'] : this.quizEnvelop.question_count


  }

  async processImages(question:Question){
    let qText = question.questionText
    let myImages= question.imageListQuestionBody

    let iLength = myImages.length

    if(iLength==0){
      this.questionText=question.questionText
      this.loading=false
      this.generating=false
      this.reloading=false
    }

   const imageObservables =myImages.map(pp=>this.imageService.questionObservableImage(this.question.server_question_id,pp['media_file_name']))
   forkJoin(imageObservables).subscribe({
    next:(resultArray)=>{
    for(let i=0;i < resultArray.length;i++){
    let iValue = resultArray[i].rs.data

    let  myImageData = myImages[i]
    let  partName = myImageData['name']
    let  placement = myImageData['placement']
    let imagePlaceHoler = "@@image"+partName
    let imageSource =  "<img src=data:image/png;base64,"+iValue+">"
    if(placement!="IN_LINE_YES"){imageSource= "<div>"+imageSource+"</div>"}
    qText =this.replaceAll(qText,imagePlaceHoler,imageSource)
  }
  this.questionText=qText

  this.loading=false
  this.generating=false
  this.reloading=false
  },error:(err)=>{
    console.error("Error loading images",err)
  }
  }
  )
  }

  // processImages(){
  //   let qText = this.question.questionText
  //   let myImages= this.question.imageListQuestionBody
  //   if(myImages.length==0){
  //     this.loading=false
  //     this.renderMathRequest.emit(true)

  //   }
  //   let oList = []

  //   for(let i=0;i < myImages.length;i++){
  //      let   myImageData = myImages[i]
  //      let   partName = myImageData['name']
  //      oList.push(this.imageService.questionImage(this.question.server_question_id,partName))
  //    }

  //  forkJoin(oList).subscribe(
  //        resultArray=>{
  //         for(let i=0;i < myImages.length;i++){
  //           let iValue = resultArray[i]
  //           let  myImageData = myImages[i]
  //           let  partName = myImageData['name']
  //           let  placement = myImageData['placement']
  //           let imagePlaceHoler = "@@image"+partName
  //           let imageSource =  "<img src=data:image/png;base64,"+iValue+">"
  //           if(placement!="IN_LINE_YES"){imageSource= "<div>"+imageSource+"</div>"}
  //           qText =this.replaceAll(qText,imagePlaceHoler,imageSource)
  //         }
  //         this.question.questionText=qText
  //         this.loading=false

  //         this.renderMathRequest.emit(true)


  //        }
  //      )
  // }

  replaceAll(str:string, find:string, replace) {
    return str.replace(new RegExp(find,'g'), replace);
  }
}
